import 'material-design-lite';

import domReady from './Libs/domReady';

import ajaxLoad from './Module/ajaxLoad';
import navigation from './Module/navigation';

navigation.init();

domReady(function() {
    ajaxLoad.initAjax();
});
